import { IconQuestionCircleOutlined } from "@suse-o11y/icons";
import React from "react";

import { FormField } from "~/components/form/field";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";
import { Input } from "~/components/input";
import { Switch } from "~/components/switch";
import { SwitchLabel } from "~/components/switch/label";
import { Tooltip } from "~/components/tooltip";
import { TooltipContent } from "~/components/tooltip/content";
import { TooltipTrigger } from "~/components/tooltip/trigger";

import type { FormState } from "./_form-state";

export interface VariableFormProps {
	state: FormState;
}

export const VariableForm: React.FC<VariableFormProps> = ({ state }) => (
	<>
		<FormField state={state.fields.value}>
			<FormLabel asChild>
				<div>
					<FormLabel>Value</FormLabel>
					<FormFieldReset />
				</div>
			</FormLabel>

			{(monitor, field) => (
				<Input
					name="dashboard-text-variable-value"
					onChange={(event) => field.setInput(event.target.value)}
					value={field.getInput(monitor)}
				/>
			)}
		</FormField>

		<FormField state={state.fields.readOnly}>
			{(fieldMonitor, field) => (
				<div className="flex w-full items-center gap-2">
					<SwitchLabel className="flex items-center gap-2">
						<Switch
							checked={field.getInput(fieldMonitor)}
							name="dashboard-text-variable-read-only"
							onCheckedChange={(checked) => field.setInput(checked)}
						/>
						Make read-only
					</SwitchLabel>

					<Tooltip delayDuration={300}>
						<TooltipTrigger className="cursor-help!">
							<IconQuestionCircleOutlined />
						</TooltipTrigger>

						<TooltipContent>
							When enabled, users won't be able to edit or remove the variable from the dashboard
						</TooltipContent>
					</Tooltip>

					<div className="flex flex-1 justify-end">
						<FormFieldReset />
					</div>
				</div>
			)}
		</FormField>
	</>
);
